import { GoogleMapModalComponent } from './google-map-modal.component';

export default angular
  .module('sfMobile.components.google-map-modal', [
    'sfMobile.components.google-map',
    'sfMobile.services.geolocation',
  ])
  .component('sfGoogleMapModal', GoogleMapModalComponent).name;
